import React from 'react';

function Unauthorized() {
    return <h5>Whoops! It seems you don't have the necessary permissions to access this page.</h5>;
}

export default Unauthorized;
